//account-global-functions.js
const getAppUrl = () => {
    return 'https://brightland-apps.com';
};

// switch to ngrok server when testing https://brightland-cli-prod.herokuapp.com